module.exports = __webpack_public_path__ + "static/img/belenEduca.a878b0ed.png";